// extracted by mini-css-extract-plugin
export default {"wrapper":"eLyNnbmzcigi8lDvzHPA"};